import _regeneratorRuntime from 'babel-runtime/regenerator';

var _apexMenuReducers;

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(apexMenuSagas);

import { all } from 'redux-saga/effects';
import ApexOnlineMenu from './ApexOnlineMenu';
import * as menuItems from './MenuItemsService';
import * as menuPermissions from './MenuPermissionsService';
import * as legacyUrl from './LegacyUrlService';
export * from './ApexOnlineMenu/constants';

var apexMenuReducers = (_apexMenuReducers = {}, _apexMenuReducers[menuItems.NAMESPACE] = menuItems.reducer, _apexMenuReducers[menuPermissions.NAMESPACE] = menuPermissions.reducer, _apexMenuReducers[legacyUrl.NAMESPACE] = legacyUrl.reducer, _apexMenuReducers);

function apexMenuSagas() {
  return _regeneratorRuntime.wrap(function apexMenuSagas$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return all([menuItems.menuItemsFlow(), menuPermissions.menuPermissionsFlow(), legacyUrl.legacyUrlFlow()]);

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

export { ApexOnlineMenu, menuItems, menuPermissions, legacyUrl, apexMenuReducers, apexMenuSagas };